import React, { useEffect, useState } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import * as actionLinePicking from '../../../../actions/linePickingAction';
import Breadcrumbs from '../../../../components/UI/Breadcrumbs';
import { Button } from '../../../../components/UI/ComponentsUI';
import ScannerCode from '../../../../components/UI/ScannerCode';
import PickingService from '../../../../services/PickingService';
import { ENUMS } from '../../../../utils/constants';
import { isNullOrEmpty, translate, showMessageToastCustom } from '../../../../utils/util';
import * as actionsPicking from '../../../../actions/pickingAction';
import LinePickingService from '../../../../services/LinePickingService';
import InputUI from '../../../../components/UI/InputUI';

const WriteOff = (props) => {
    let statusList = [
        ENUMS.eOrderStatus.Waiting.value,
        ENUMS.eOrderStatus.InProgress.value,
        ENUMS.eOrderStatus.WaitingRouteComposition.value,
        ENUMS.eOrderStatus.WaitingRouteInformation.value
    ]

    const [orderCode, setOrderCode] = useState('');
    const [refreshed, setRefreshed] = useState(false);
    let inputFilter;

    useEffect(() => {
        if (inputFilter) {
            inputFilter.focus();
        }
        // eslint-disable-next-line
    }, [inputFilter]);

    const refreshComponent = () => {
        setRefreshed(!refreshed);
    };

    const applyFilter = (orderCode) => {
        if (!isNullOrEmpty(orderCode)) {
            props.filter.orderCode = orderCode;
            props.filter.orderType = ENUMS.eOrderType.LinePicking.value;
            props.filter.status = statusList;
            props.setFilterOrder(props.filter);
            props.writeOffOrder(orderCode, (response) => {
                setOrderCode("");
                showMessageToastCustom(translate('general.info'), translate('messages.write-off-success', 'line-picking'), 5000, 'mdi mdi-checkbox-marked-circle-outline green-text');
            });
            refreshComponent();
        }
    };

    const subtitlesPickingFilterByOrder = () => {
        return [{ icon: "mdi mdi-filter-variant", label: translate('expedition:picking.filterByTD') }];
    }

    const scannerBarCode = (code) => {
        setOrderCode(code);
        applyFilter(code);
    }

    const onChangeOrderCode = (code) => {
        setOrderCode(code);
        if (code.length === 12) {
            applyFilter(code);
        }
    }


    return (
        <div>
            <Breadcrumbs id="pickingFilterByOrder" subtitles={subtitlesPickingFilterByOrder()} />
            <div className="container" style={{ marginTop: '40px', }}>
                <div className="row">
                    <div className="input-field no-padding col s12">
                        <InputUI
                            id="orderCode"
                            type="text"
                            label="TD"
                            required
                            name="orderCode"
                            maxLength="12"
                            value={orderCode}
                            onChange={(event) => onChangeOrderCode(event.target.value)}
                        />
                        <ScannerCode onScanner={scannerBarCode} />
                    </div>
                </div>
                <div className="row">
                    <Button onClick={() => props.history.goBack()} text={translate('cancel', 'general')} secundary="true" full="true" />
                </div>
            </div>
        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        filter: state.linePickingReducer.filter
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        setFilterOrder: (filter) => {
            dispatch(actionLinePicking.setFilter(filter));
        },
        getOrders: (filter, pagination, callback) => {
            dispatch(LinePickingService.getOrders(filter, pagination, callback));
        },
        setFilterOrderItem: (filter) => {
            dispatch(actionsPicking.setFilter(filter));
        },
        writeOffOrder: (orderCode, callback) => {
            dispatch(PickingService.writeOffOrder(orderCode, callback));
        },
        setSelectedMission: (mission) => {
            dispatch(actionLinePicking.selectMission(mission));
        },
        updateMissionStatus: (orderItemId, status) => {
            dispatch(actionLinePicking.updateMissionStatus(orderItemId, status));
        },
        startOrder: (orderId, callback) => {
            dispatch(LinePickingService.startOrder(orderId, callback));
        },
        startOrderItem: (orderId, orderItemId, callback) => {
            dispatch(LinePickingService.startOrderItem(orderId, orderItemId, callback));
        },
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTranslation()(WriteOff)));
